var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import css2json from 'css2json';
import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import { calculateFitToPreviewPxSize, convertObjectToCss } from '../../util-components/zone-layout';
import Popover from '../popover';
import { Styled } from './style';
var defaultConfig = {
    css: "<style>#zone1{position:absolute;width:100%;height:100%;top:0;left:0;z-index:10;}</style>",
    width: 1920,
    height: 1080,
    zones: [
        {
            id: 'zone1',
            name: 'Top Left',
        },
    ],
    is_flexible: true,
    is_scalable: true,
};
var ZoneLayout = /** @class */ (function (_super) {
    __extends(ZoneLayout, _super);
    function ZoneLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.handleZoneClick = function (zoneId) {
            if (_this.props.onClick) {
                _this.props.onClick(zoneId);
            }
        };
        return _this;
    }
    ZoneLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, config = _a.config, channelWidth = _a.channelWidth, onClick = _a.onClick, activeZone = _a.activeZone, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, width = _a.width, height = _a.height, orientation = _a.orientation, isFlexible = _a.isFlexible, isScalable = _a.isScalable;
        var layoutClassname = "layout " + activeZone + " " + (orientation ? orientation.toLowerCase() : '') + " " + (onClick ? 'clickable' : '');
        var cleanedStyle = config.css.replace('<style>', '').replace('</style>', '');
        var styleData = css2json(cleanedStyle);
        var divWidth = 160;
        var divHeight = 90;
        var divTop = 0;
        var divLeft = 0;
        var divMaxWidth = maxWidth ? maxWidth : divWidth;
        var divMaxHeight = maxHeight ? maxHeight : divWidth; // if not provide maxHeight it will try to render in the SQUARE box of divWidth x divWidth
        if (width && height) {
            var scaleW = divMaxWidth / width;
            var scaleH = divMaxHeight / height;
            var finalAspectRatio = ((scaleH * width) < divMaxWidth) ? scaleH : scaleW;
            if (!isFlexible && !isScalable) {
                // fixed pixel, if specific ChannelWidth then using the Channel's scaling
                finalAspectRatio = channelWidth ? (divMaxWidth / channelWidth) : finalAspectRatio;
            }
            divWidth = Math.ceil(finalAspectRatio * width);
            divHeight = Math.ceil(finalAspectRatio * height);
        }
        if (isFlexible || isScalable) {
            divLeft = (divMaxWidth - divWidth) / 2;
            divTop = (divMaxHeight - divHeight) / 2;
        }
        var styleObject = _.cloneDeep(styleData);
        var formattedStyleObj = _
            .chain(styleObject)
            .toPairs()
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            if (key !== '#zone-hidden' && value.height && value.height.includes('px') && height) {
                value.height = calculateFitToPreviewPxSize({ layoutSize: height, previewSize: divHeight, customSize: value.height });
            }
            if (key !== '#zone-hidden' && value.width && value.width.includes('px') && width) {
                value.width = calculateFitToPreviewPxSize({ layoutSize: width, previewSize: divWidth, customSize: value.width });
            }
            return [key, value];
        })
            .fromPairs()
            .value();
        var cssStyled = convertObjectToCss(formattedStyleObj);
        var CustomStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), cssStyled);
        return (React.createElement(Styled, { className: layoutClassname, style: { width: divWidth, height: divHeight, top: divTop, left: divLeft } },
            React.createElement(CustomStyle, null, config && config.zones.map(function (zone, idx) {
                var zoneIdStyle = styleData['#' + zone.id];
                if (zoneIdStyle) {
                    var zoneWidth = zoneIdStyle.width ? Math.round(width * zoneIdStyle.width.replace('%', '') / 100) : '';
                    var zoneHeight = zoneIdStyle.height ? Math.round(height * zoneIdStyle.height.replace('%', '') / 100) : '';
                    if (zoneIdStyle.width && zoneIdStyle.width.includes('px')) {
                        zoneWidth = +zoneIdStyle.width.split('px')[0];
                    }
                    if (zoneIdStyle.height && zoneIdStyle.height.includes('px')) {
                        zoneHeight = +zoneIdStyle.height.split('px')[0];
                    }
                    return (React.createElement(Popover, { className: "code-pop", inverted: true, key: idx, trigger: React.createElement("div", { className: "zone " + (_this.props.activeZone === zone.id ? 'active' : ''), id: zone.id, onClick: onClick ? function () { return _this.handleZoneClick(zone.id); } : undefined },
                            React.createElement("span", null, idx + 1)), content: React.createElement(React.Fragment, null,
                            React.createElement("span", null,
                                "w:",
                                zoneWidth),
                            React.createElement("span", null,
                                "h:",
                                zoneHeight)), position: "top center" }));
                }
                return;
            }))));
    };
    ZoneLayout.defaultProps = {
        config: defaultConfig,
        width: 1920,
        height: 1080,
    };
    return ZoneLayout;
}(React.Component));
export default ZoneLayout;
var templateObject_1;
//# sourceMappingURL=index.js.map